import {createAction, PayloadAction} from '@reduxjs/toolkit';
import {call, ForkEffect, put, takeLatest} from 'redux-saga/effects';

import {
  deleteProject,
  fail,
  requesting,
  success,
} from 'App/features/searchEntities/lightProjects/lightProjectsSlice';

import * as log from '../../../../../logger';
import {remove} from '../lightProjectsApi';

type RequestDeleteLightProjectPayload = {
  projectHash: string;
};

export const requestDeleteLightProject = createAction(
  'lightProjects/requestDeleteLightProject',
);

function* requestDeleteLightProjectSaga({
  payload,
}: PayloadAction<RequestDeleteLightProjectPayload>) {
  yield put(requesting());
  try {
    yield call(remove, payload.projectHash);
    yield put(deleteProject(payload));
    yield put(success());
  } catch (error) {
    if (error instanceof Error) {
      yield call(log.exception, error);
    }
    yield put(fail({error: 'requestDeleteLightProjectError'}));
  }
}

function* watchRequestDeleteLightProject(): Generator<
  ForkEffect<void>,
  void,
  unknown
> {
  yield takeLatest(
    requestDeleteLightProject.type,
    requestDeleteLightProjectSaga,
  );
}

export default watchRequestDeleteLightProject;
